import React, { useEffect, useRef, useState } from 'react'
import style from "../Verifier/VerifyUsers.module.css"
import cogoToast from 'cogo-toast-react-17-fix'
const SearchDropdown = ({apidata=[], displayKey="name", placeholder="Search", value=null, onSelect, width="29rem", showId=false, onFocus}) => {
    const [query, setQuery]=useState("")
    const [filteredList, setFilteredList] = useState([])
    const [showList, setShowList] = useState(false)
    const [selectedItem, setSelectedItem]=useState(null)
    const wrapperRef = useRef(null)


    useEffect(() => {
      if (value) {
        setQuery(value[displayKey] || "")
        setSelectedItem(value)
        // onSelect(value)
      }
    }, [value, displayKey])
    // useEffect(() => {

    //   if (filteredList.length === 0) {
    //     onSelect && onSelect("");
    //   }
    // }, [filteredList, onSelect])
    useEffect(()=>{
      if (query.trim() === "") {
        setFilteredList(apidata);
      } 
      else {
        const result = apidata.filter(item =>
          item[displayKey]?.toLowerCase().includes(query.toLowerCase())
        );
        setFilteredList(result);
      }
    },[query, apidata, displayKey])
    useEffect(() => {
      function handleClickOutside(event) {
        if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
          setShowList(false)
        }
      }
      document.addEventListener("mousedown", handleClickOutside)
      return () => {
        document.removeEventListener("mousedown", handleClickOutside)
      }
    }, [])


    const handleChange = (e) => {
      const value = e.target.value
      if (value.trim() === "") {
        setQuery("")
        setSelectedItem("")
        onSelect && onSelect("")
        return
      }
      setQuery(value)
    }
    const handleSelect = (item) => {
      if (filteredList.length === 0) {
        cogoToast.error("Please select a valid option from the list");
        return;
      }
      setQuery(item[displayKey])
      setSelectedItem(item)
      setShowList(false)
      if (onSelect) onSelect(item)
    }
  return (
    <>
    <div style={{position: "relative", width: "250px"}} ref={wrapperRef}>

        <input type='text' className={style.selectItem} value={query} style={{width:width}} placeholder={placeholder} onClick={()=>setShowList(true)} onChange={(e)=>handleChange(e)} onFocus={() => {
    setQuery("");
    setSelectedItem(null);
    setShowList(true);

    onFocus && onFocus();
  }}/>
      {

        showList && (
          <ul
          style={{
            width: width,
            position: "absolute",
            top: "100%",
            left: 0,
            right: 0,
            maxHeight: "200px",
            overflowY: "auto",
            border: "1px solid #ccc",
            background: "#fff",
            zIndex: 9999,
            margin: 0,
            padding: 0,
            listStyle: "none",
            border:"1px solid lightgray",
            borderRadius:"10px"
          }}
        >
          {filteredList.length > 0 ? (
            filteredList.map((item) => (
              <li
                key={item.id}
                onClick={() => handleSelect(item)}
                style={{
                  padding: "8px",
                  cursor: "pointer",
                  background: selectedItem?.id === item.id ? "#f0f0f0" : "#fff",
                }}
              >
                {`${item[displayKey]} ${showId? (item.client_id==null?"":`(${item.client_id})`):""}`}
              </li>
            ))
          ) : (
            <li style={{ padding: "8px", color: "#888" }}>No results</li>
          )}
        </ul>
        )
      }
    </div>
    </>
  )
}

export default SearchDropdown